import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "src/hooks/redux";
import {
  inProgressDealAsync,
  cancelDealAsync,
} from "src/redux/currentDeal/actions";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as RejectIcon } from "src/assets/icons/circle-x-mark.svg";
import { ReactComponent as ConfirmIcon } from "src/assets/icons/confirm.svg";
import { defaultDealTrns } from "../trns";

const DEFAULT_BUTTON_CLASSNAME = "flex items-center gap-2.5 w-full";

interface Props {
  dealId: number;
}

export const ActionButtons: FC<Props> = ({ dealId }) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const onConfirm = () => {
    dispatch(inProgressDealAsync(dealId));
  };

  const onReject = () => {
    dispatch(cancelDealAsync(dealId));
  };

  return (
    <div className="flex flex-col lg:flex-row gap-3 lg:gap-5">
      <Button
        variant={ButtonVariants.GRAY}
        className={DEFAULT_BUTTON_CLASSNAME}
        onClick={onReject}
      >
        <RejectIcon />
        <span>{t(defaultDealTrns.rejectButton)}</span>
      </Button>

      <Button
        variant={ButtonVariants.GRAY}
        className={DEFAULT_BUTTON_CLASSNAME}
        onClick={onConfirm}
      >
        <ConfirmIcon />
        <span>{t(defaultDealTrns.confirmButton)}</span>
      </Button>
    </div>
  );
};
